<script type="text/babel">
  import Vue from 'vue'
  import plugin from './plugin'
  const component = Vue.component('loading',{
    props:{
      text:{
        type:String,
        default:'Loading...'
      },
      show: {
        type: Boolean,
        default: false
      }
    },
    template: `<div class="loading" v-show="show">
      {{show}}
      <div class="text">
        <span class="s-jump" v-for="(index, item) in text" transition="jump" track-by="$index" :style="{'animationDelay':index*1+'s'}">{{item}}</span>
      </div>
    </div>`
  })

  Vue.use(plugin, component)
  export default  component
</script>

<style lang="less" rel="stylesheet/less">
.loading{
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.5);
  z-index: 10000;
}
.text{
    font-size: 40px;
    text-align: center;
    position: absolute;
    top: 40%;
    // perspective:100;
    // perspective-origin: 50% 100%;
    width: 100%;
}
.s-jump{
  animation: jump 10s ease 0s infinite;
  display: inline-block;
  position: relative;
  // width: 50px;
  padding: 0 10px;
  // transform-origin:100% 0 0;
  // color:transparent;
  color:#fff;
}
@keyframes jump {
  0% {
    // transform: translateZ(0px);
    transform: translateY(0px);
    // transform: rotateX(0);
    // transform: scale(1);
    // color:#f00;
    // color:#2b65e2;
  }
  3% {
    // transform: translateZ(20px);
    transform: translateY(-100px);
    // transform: scale(1.5);
    // transform: rotateX(90deg);
    // color:#ff0;
    // color:#658fd8;
  }
  6% {
    transform: translateY(30px);
  }
  10% {
    // transform: translateZ(0px);
    transform: translateY(0px);
    // transform: rotateX(0deg);
    // transform: scale(1);
    // color:#0f0;
    // color:#a1c3ff;
  }
}

</style>



// WEBPACK FOOTER //
// index.vue?b62abf18